import React from "react";

// components

import BlogsTable from "views/admin/components/Blogs/ListBlog";

export default function Blogs() {
  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12 px-4">
          <BlogsTable />
        </div>
      </div>
    </>
  );
}